// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"66abd30f","260":"66616882","294":"72b8928e","310":"b00c0232","385":"96e0d541","626":"bc17798b","660":"902346ab","785":"7e5286a7","787":"66ead447","932":"b6e826f4"}[chunkId] + ".chunk.js";
};